import { IntlShape } from 'react-intl'
import { isDisposableEmail } from 'disposable-email-domains-js'

export const validateEmail = (value: string, intl: IntlShape) => {
  if (isDisposableEmail(value)) {
    return intl.formatMessage({ id: 'form.forbidden_email_domain' })
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return intl.formatMessage({ id: 'form.invalid_email' })
  }
  return true
}

export const validateRequired = (intl: IntlShape) => ({
  required: {
    value: true,
    message: intl.formatMessage({ id: 'form.required' })
  }
})

export const validatePhone = (value: string, intl: IntlShape) => {
  return (
    /^[\d.\-+() #,]*\s*(ext|extension)?\s*[\d.\-+() #,]*$/i.test(value) ||
    intl.formatMessage({ id: 'form.invalid_phone' })
  )
}
